export default __webpack_public_path__ + "static/media/fond-zero_pan_2.ef55113d.png";